import { lazy } from 'react';

// project imports
import Loadable from 'components/ui-component/Loadable';
import WorkflowLayout from 'layout/WorkflowLayout';
import PrivateRoute from 'components/routing/PrivateRoute';

// Workflow routing
const StagesModel = Loadable(lazy(() => import('views/workflow/WorkFlow-Pages/Stages-Allocation')));

const CaseDetails = Loadable(lazy(() => import('views/workflow/WorkFlow-Pages/loan-details/loan-details-page')));

// Stages routing
const Stage = Loadable(lazy(() => import('views/workflow/WorkFlow-Pages/Stage-Main')));

// SubWorkflows routing
const SubWorkflow = Loadable(lazy(() => import('views/workflow/WorkFlow-Pages/SubWorkflow-Main')));

// Pages routing
const Page = Loadable(lazy(() => import('views/workflow/WorkFlow-Pages/Page-Main')));

// 404 routing
const ErrorFourNotFour = Loadable(lazy(() => import('components/ui-component/FourNotFour/workflow')));

// ==============================|| WORKFLOW ROUTING ||============================== //

const WorkFlowRoutes = {
	path: '/workflows',
	element: (
		<PrivateRoute>
			<WorkflowLayout />
		</PrivateRoute>
	),
	children: [
		{
			path: ':workflowId',
			element: <StagesModel />,
		},
		{
			path: ':workflowId/case-details',
			element: <CaseDetails />,
		},
		{
			path: ':workflowId/sub-workflows/:subWorkflowId',
			element: <SubWorkflow />,
		},
		{
			path: ':workflowId/stages/:stageId',
			element: <Stage />,
		},
		{
			path: ':workflowId/stages/:stageId/pages/:pageId',
			element: <Page />,
		},

		{
			path: '*',
			element: <ErrorFourNotFour />,
		},
	],
};

export default WorkFlowRoutes;
